import Promise from "bluebird";

const tools = {
  loadFileWait: (src, callback) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    /* eslint-disable no-multi-assign */
    s.onreadystatechange = s.onload = function() {
      if (
        !callback.done &&
        (!s.readyState || /loaded|complete/.test(s.readyState))
      ) {
        callback.done = true;
        callback();
      }
    };
    s.onerror = () => {
      callback("aie");
    };
    document.querySelector("head").appendChild(s);
  },
  loadFile: async (url, type, elem) =>
    new Promise(resolve => {
      const El = document.getElementsByTagName(elem)[0];
      let link = {};
      if (type === "script") {
        link = document.createElement(type);
        link.type = "text/javascript";
        link.src = url;
      } else if (type === "link" || type === "css") {
        link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.media = "all";
        link.href = url;
      }
      if (link.addEventListener) {
        link.addEventListener("load", resolve, false);
      } else if (link.readyState) {
        link.onreadystatechange = resolve;
      }
      El.appendChild(link);
      setTimeout(() => {
        resolve();
      }, 1000);
    }),
  addCSS: (name, content) => {
    const css = content;
    const body = document.body || document.getElementsByTagName("body")[0];
    const style = document.createElement("style");

    style.className += `vjs-style-${name}`;
    style.type = "text/css";
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    body.appendChild(style);
  },
  removeDIV: name => {
    const els = document.getElementsByClassName(name);
    if (!els.array) {
      return false;
    }
    els.array.forEach(element => {
      element.parentNode.removeChild(element);
    }, this);
    return true;
  },
  browsers: () => {
    const ua = navigator.userAgent.toLowerCase();
    const browsers = {};
    browsers.msie =
      ua.indexOf("msie") !== -1 ? parseInt(ua.split("msie")[1], 10) : true;
    browsers.ms =
      navigator.appName === "Microsoft Internet Explorer" ||
      navigator.appVersion.indexOf("Edge") >= 0 ||
      navigator.appVersion.indexOf("Trident") >= 0;
    browsers.edge = navigator.appVersion.indexOf("Edge") >= 0;
    browsers.touchDevice = "ontouchstart" in document.documentElement;
    browsers.winSFirefox = false;
    if (ua.indexOf("firefox") !== -1) {
      if (
        ua.indexOf("windows nt 6.1") !== -1 ||
        (navigator.oscpu && navigator.oscpu.indexOf("Windows NT 6.1") !== -1)
      ) {
        browsers.winSFirefox = true;
      }
    }
    browsers.android = false;
    browsers.safari = false;
    // IE 9 wtf..
    if (!browsers.msie) {
      browsers.android = ua.indexOf("android") > -1;
      browsers.safari = navigator.vendor.indexOf("Apple") >= 0;
    }

    return browsers;
  },
  cleanPlugins: plugins => {
    const toRemove = [
      "vjs-logo",
      "vjs-infoButton",
      "vjs-socialButton",
      "vjs-quality-container",
      "vjs-program",
    ];
    if (!plugins.videojs_multiple_audio) {
      toRemove.push("vjs-audio-button");
      tools.addCSS("no-audio-button", ".vjs-audio-button{display: none;}");
    } else {
      tools.addCSS("audio", ".vjs-audio-button{display:block !important;}");
    }

    try {
      toRemove.forEach(element => {
        tools.removeDIV(element);
      });
    } catch (e) {
      // console.log(e);
    }
    try {
      if (!plugins.videojs_dvrseekbar) {
        [
          ...document.querySelectorAll(
            ".vjs-dvrseekbar-progress-control,.vjs-progress-control",
          ),
        ].forEach(element => {
          element.style.height = 0;
          element.style.overflow = "hidden";
          element.style.opacity = 0;
        });
        tools.addCSS(
          "noDVR",
          ".vjs-live-display, .vjs-remaining-time{display:none !important;}",
        );
      }
    } catch (error) {
      console.error(error);
    }
  },
  createVideoElement: options => {
    let el = document.getElementById(options.playerID);

    if (el.tagName !== "video") {
      // Replace div (for ie) by video
      const newNode = document.createElement("video");
      const container = el.parentNode;

      newNode.setAttribute("id", options.playerID);
      newNode.setAttribute("playsinline", "");

      if (options.simple) {
        newNode.setAttribute("autoplay", "");
        newNode.setAttribute("loop", "");
        newNode.setAttribute("muted", "");
      }
      container.removeChild(el);
      container.insertBefore(
        newNode,
        document.querySelector(".playlist-container"),
      );

      el = document.getElementById(options.playerID);
      el.className += el.className ? " video-js" : "video-js";
      el.className += " vjs-default-skin vjs";
    }

    el.setAttribute("playsinline", "");

    if (options.simple) {
      el.setAttribute("autoplay", "");
      el.setAttribute("loop", "");
      el.setAttribute("muted", "");
    }

    el.className += el.className ? " video-js" : "video-js";
    el.className += " vjs-default-skin vjs";
    if (options.radio || options.large) {
      el.className += " vjs-16-9";
    }
    el.className += " vjs-big-play-centered";
    return el;
  },
};

export default tools;



// WEBPACK FOOTER //
// ./src/js/utils/tools.js